import { type JSX } from 'react/jsx-runtime';

import { NonMauChatCtaMessage } from '../../../common/components/NonMauChatCtaMessage';
import { createRender, type HydrationResult } from './types';

export const render: (
	renderProps: Omit<HydrationResult, 'postOffice'> & {
		onDismissed: () => void;
	},
) => JSX.Element | null = createRender(({ onDismissed }) => {
	return (
		<NonMauChatCtaMessage
			handleOnDismissed={onDismissed}
			context={{
				source: 'jira-side-nav',
			}}
		/>
	);
});

export default render;
